import { createEntityAdapter, EntityState, EntityAdapter } from '@ngrx/entity';

import { Company } from '../../companies.model';

import * as companyActions from '../actions/companies.actions';
import { ActionType } from '../actions/companies.actions';

export interface State extends EntityState<Company> { fetchRunning: null; addCompanyStatus: { status: null, id: null }; }

export const companyAdapter: EntityAdapter<Company> = createEntityAdapter<Company>();

export const initialState: State = companyAdapter.getInitialState({ fetchRunning: null, addCompanyStatus: { status: null, id: null } });

export function companyReducer(
  state: State = initialState,
  action: companyActions.CompanyActions
) {
  switch (action.type) {

    case ActionType.FETCH_COMPANIES_BY_COMPANYNAME_SUCCESS:
      return companyAdapter.setAll(action.companies, {
        ...state,
        fetchRunning: false,
        status: true,
      });

    case ActionType.FETCH_COMPANYS_SUCCESS:
      return companyAdapter.setAll(action.companies, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.FETCH_COMPANY_SUCCESS:
      companyAdapter.removeAll({
        ...state,
        fetchRunning: false,
      });

      return companyAdapter.setAll(action.companies, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.ADD_COMPANY:
      return {
        ...state,
        fetchRunning: true,
        addCompanyStatus: { status: false, id: null }
      };
    case ActionType.ADD_COMPANY_SUCCESS:
      return companyAdapter.addOne(action.company, {
        ...state,
        fetchRunning: false,
        addCompanyStatus: { status: true, id: action.company.id }
      });

    case ActionType.ADD_COMPANY_FAILED:
      return {
        ...state,
        fetchRunning: false,
        addCompanyStatus: { status: false, id: null }
      };

    case ActionType.DELETE_COMPANY:
      return {
        ...state,
        fetchRunning: true,
      };
    // case ActionType.DELETE_COMPANY_SUCCESS:
    //   return companyAdapter.removeOne(action.id, {
    //     ...state,
    //     fetchRunning: false,
    //   });

    case ActionType.DELETE_COMPANY_FAILED:
      return {
        ...state,
        fetchRunning: false,
      };
    case ActionType.UPDATE_COMPANY:
      return {
        ...state,
        fetchRunning: true,
      };

      case ActionType.UPDATE_COMPANY_SUCCESS:
        return companyAdapter.updateOne({ id: action.id, changes: action.changes, }, {
          ...state,
          fetchRunning: false,
        });

    case ActionType.UPDATE_COMPANY_FAILED:
      return {
        ...state,
        fetchRunning: false,
      };



    //  return companyAdapter.addOne(action.payload.company, state);
    // case companyActions.TOGGLE_DONE:
    //   return companyAdapter.updateOne(
    //     { id: action.payload.id, changes: { done: action.payload.done } },
    //     state
    //   );
    // case companyActions.UPDATE_COMPANY:
    //   return companyAdapter.updateOne(
    //     { id: action.payload.id, changes: { value: action.payload.newValue } },
    //     state
    //   );
    // case companyActions.DELETE_COMPANY:
    // return companyAdapter.removeOne(action.payload.id, state);



    default:
      return state;
  }
}

export const getFetchRunning = (state: State) => state.fetchRunning;
export const getCompanyStatus = (state: State) => state.addCompanyStatus;
export const getAllOfTheCompanies = ( (state: State) => {

  return state.entities;

});

// export const getAllOfTheCompanies =( (state: State) => {

//   let xxx = [];

//   for (const key of Object.keys(state.entities)) {
//     const value = state.entities[key] as Company
//     // console.log(`${key} -> ${value}`)
//     // console.log("value", value)

//     xxx.push(value);
//  }

//   return xxx.filter((book: Company) => book.id === '3afc1e44-ee49-d1a0-3b41-f4441cd5a8ce');

// });

